import { useCallback } from "react";

/** Attorney select / clear / home-address toggle. */
export function useBondPrincipalAttorneyHandlers({ cfg, keys, data, updateData, attorneys }) {
  const handleAttorneySelection = useCallback(
    (index, attorney) => {
      if (cfg.attorneyUi === "va") {
        if (!attorney) return;
        const updatedGuardians = [...data.guardians];
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          [keys.name]: attorney.label,
          [keys.address]: attorney.address,
          email: attorney.email,
          [keys.city]: attorney.city,
          [keys.state]: attorney.state,
          [keys.zip]: attorney.zip_code,
          is_attorney: "Yes",
          [keys.occupation]: attorney.position,
          [keys.relationship]: "Attorney of Record",
          [keys.citizenship]: "USA",
          [keys.country]: "USA",
          attorney: attorney.value,
          showAttorneyForm: false,
        };
        updateData({ ...data, guardians: updatedGuardians });
        return;
      }

      if (attorney) {
        const updatedGuardians = [...data.guardians];
        const patch = {
          [keys.name]: attorney.label,
          [keys.address]: attorney.address,
          email: attorney.email,
          [keys.city]: attorney.city,
          [keys.state]: attorney.state,
          [keys.zip]: attorney.zip_code,
          is_attorney: "Yes",
          is_attorney_home: "No",
          [keys.occupation]: attorney.position,
          [keys.relationship]: "Attorney of Record",
          [keys.citizenship]: "USA",
          [keys.country]: "USA",
          attorney: attorney.value,
          showAttorneyForm: false,
        };
        if (cfg.pgFetchIncludesGiaLoa) {
          patch.attorney_gia_on_file = !!attorney.is_gia_on_file;
          patch.is_esignatures_principal = attorney.is_gia_on_file
            ? "No"
            : updatedGuardians[index].is_esignatures_principal || "No";
        }
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          ...patch,
        };
        updateData({ ...data, guardians: updatedGuardians });
      } else {
        const updatedGuardians = [...data.guardians];
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          is_attorney: "No",
          is_attorney_home: "No",
          attorney: null,
          [keys.name]: "",
          [keys.address]: "",
          [keys.city]: "",
          [keys.state]: "",
          [keys.zip]: "",
          [keys.occupation]: "",
          [keys.relationship]: "",
        };
        if (cfg.pgFetchIncludesGiaLoa) {
          updatedGuardians[index].attorney_gia_on_file = false;
        }
        updateData({ ...data, guardians: updatedGuardians });
      }
    },
    [cfg, data, keys, updateData]
  );

  const handleAttorneyHomeAddressChange = useCallback(
    (index, value) => {
      const updatedGuardians = [...data.guardians];
      const guardianRow = updatedGuardians[index];
      const attorneyRow = attorneys.find((a) => a.value === guardianRow.attorney);

      updatedGuardians[index] = {
        ...updatedGuardians[index],
        is_attorney_home: value,
      };

      if (value === "Yes") {
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          [keys.address]: "",
          [keys.city]: "",
          [keys.state]: "",
          [keys.zip]: "",
        };
      } else if (attorneyRow) {
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          [keys.address]: attorneyRow.address,
          [keys.city]: attorneyRow.city,
          [keys.state]: attorneyRow.state,
          [keys.zip]: attorneyRow.zip_code,
        };
      }

      updateData({ ...data, guardians: updatedGuardians });
    },
    [attorneys, data, keys, updateData]
  );

  return { handleAttorneySelection, handleAttorneyHomeAddressChange };
}
